import { createHandlerChainRunner, HasOnError, HasOnSuccess } from "@insite/client-framework/HandlerCreator";
import { CustomApiHandler } from "@tKgpco/Store/CustomHandlerCreator";
import { UploadComingSoonProductState } from "@tKgpco/Store/Data/UploadComingSoonProduct/UploadComingSoonProductState";

type Parameters = { products: any } & HasOnSuccess & HasOnError;
type HandlerType = CustomApiHandler<Parameters, UploadComingSoonProductState>;

export const UpdatedUploadComingSoonProduct: HandlerType = props => {
    props.dispatch({
        type: "Custom/UploadComingSoonProduct/Updated",
        products: props.parameter.products,
    });
};

export const chain = [UpdatedUploadComingSoonProduct];

const uploadComingSoonProduct = createHandlerChainRunner(chain, "UploadComingSoonProduct");
export default uploadComingSoonProduct;